import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionService } from 'src/app/services/configuracion.service';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { ProductosService } from 'src/app/services/productos.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';

@Component({
  selector: 'seleccionararchivo',
  templateUrl: './seleccionararchivo.component.html',
  styleUrls: ['./seleccionararchivo.component.scss']
})
export class SeleccionarArchivoComponent implements OnInit{
  @Input() TituloMostrar: string = 'Carga de archivo';
  @Input() TextoSiMostrar: string = 'Aceptar';
  @Input() TextoNoMostrar: string = 'Cancelar';
  @Input() FiltroArchivos: string = '';
  @Input() CodigoLlamado: string = '';
  @Input() SeleccionMultiple: boolean = false;
  @Output() SeleccionoArchivo: EventEmitter<{subioArchivo: boolean, archivo: FormData, nombreArchivo: string}>;
  @ViewChild('modalseleccionararchivo', {static: false}) _ModalConfirmacion: TemplateRef<any>;
  @ViewChild('uploadFile', {static: false}) _uploadFile: ElementRef;
  subioArchivo: boolean = false;
  datosArchivo: FormData;
  nombreArchivoSeleccionado: string = '';

  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public productosService: ProductosService,
    public configuracionService: ConfiguracionService,
    public modal: MatDialog) {
      this.SeleccionoArchivo = new EventEmitter();
    }

  ngOnInit() {
    
  }

  public MostrarSeleccionArchivo() {
    let confirmacionModal = this.modal.open(this._ModalConfirmacion, { width: '60%'});

    confirmacionModal.afterClosed().subscribe(valor => {
      this.SeleccionoArchivo.emit({subioArchivo: valor, archivo: this.datosArchivo, nombreArchivo: this.nombreArchivoSeleccionado});
    });

    this.nombreArchivoSeleccionado = '';
  }
  AbrirCargarArchivo() {
    console.log('AbrirCargarArchivo');
    this._uploadFile.nativeElement.value = '';
    this._uploadFile.nativeElement.click();
  }
  ArchivoSeleccionar(_Archivos: File[]) {
    let cantidadArchivos: number = _Archivos.length;
    for (let index = 0; index < cantidadArchivos; index++) {
      this.datosArchivo = new FormData();
      this.datosArchivo.append('formFiles', _Archivos[index]);

      this.nombreArchivoSeleccionado = _Archivos[index].name;
    }
  }
}
